import {
  IUseGetUserOwnTractorTotalCountParams,
  IUseGetUserOwnTractorTotalCountReturn,
} from '../../../hooks/api/user/queries/useGetUserOwnTractorTotalCount.query';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { customAxios } from '../../common/customAxios';

type IGetUserOwnTractorTotalCountParams = Pick<IUseGetUserOwnTractorTotalCountParams, 'searchParam'>;

export const getUserOwnTractorTotalCount = ({
  searchParam,
}: IGetUserOwnTractorTotalCountParams): Promise<IUseGetUserOwnTractorTotalCountReturn> => {
  const URLSearchParams = createURLSearchParams(searchParam ?? {});
  return customAxios.get(`/users-own-tractors/total-count?${URLSearchParams}`);
};
